import { useEffect, useRef, useState } from "react";

import { delayButtonTextIn } from "NavBar/components/FloatingButtonPanel/constants";
import { create } from "zustand";

const useFloatingSearchStore = create((set) => ({
  isActive: false,
  setIsActive: (newBool) => set({ isActive: newBool }),
}));

const useIsActive = () => {
  const isActive = useFloatingSearchStore((s) => s.isActive);
  const setIsActive = useFloatingSearchStore((s) => s.setIsActive);

  return [isActive, setIsActive];
};

const useShowButtonText = () => {
  const show = !useFloatingSearchStore((s) => s.isActive);
  const [showTimeout, setShowTimeout] = useState(true);
  const timeoutRef = useRef();

  useEffect(() => {
    if (show) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(
        () => setShowTimeout(true),
        delayButtonTextIn
      );
    }
    return () => clearTimeout(timeoutRef.current);
  }, [show]);

  useEffect(() => {
    if (!show) setShowTimeout(false);
  }, [show]);

  return show && showTimeout;
};

export { useIsActive, useShowButtonText };
export default useFloatingSearchStore;
